export default __webpack_public_path__ + "static/media/store_simple_arrow.98697b47.svg";